module.exports = __webpack_public_path__ + "img/logo_ask.5164e579.png";